import React from "react";
import { RotateCcw, X } from "lucide-react";
import CampaignStatusTag from "../CampaignStatusTag";

/** One step of a campaign rotation: number, name, Meta status and id; the last step notes the loop back to 1. */
const CampaignRotationRow = ({
  campaign,
  number,
  status,
  isLast,
  onRemove,
}) => {
  return (
    <li className="relative flex items-start gap-3 px-4 py-2.5">
      {!isLast && (
        <span className="absolute bottom-[-10px] left-[27.5px] top-[34px] w-px bg-[#dcd9f7]" />
      )}
      <span className="relative flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#efedfc] text-[11px] font-semibold text-[#3c3489]">
        {number}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex min-w-0 items-start justify-between gap-2">
          <p className="min-w-0 break-words text-sm font-medium leading-snug text-gray-800">
            {campaign.campaign_name || campaign.meta_campaign_id}
          </p>
          <span className="shrink-0">
            <CampaignStatusTag status={status} />
          </span>
        </div>
        <p className="font-mono text-[11px] text-gray-400">
          {campaign.meta_campaign_id}
        </p>
        {isLast && number > 1 && (
          <p className="mt-1.5 flex items-center gap-1 text-[11px] text-gray-400">
            <RotateCcw className="h-3 w-3" />
            Then back to 1
          </p>
        )}
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="rounded-md p-1 text-gray-300 hover:bg-rose-50 hover:text-rose-600"
          aria-label="Remove campaign"
          title="Remove campaign"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </li>
  );
};

export default CampaignRotationRow;
